<script>
export default ({ props }) => {
  const { name, row, actionButtons, type } = props

  const defaultButtons = []

  if (props.check) {
    defaultButtons.push({
      name: '查看',
      permission: name ? `${name}:CHECK` : '',
      onClick: () => props.check(row),
    })
  }

  if (props.modify) {
    defaultButtons.push({
      name: '修改',
      permission: name ? `${name}:UPDATE` : '',
      onClick: () => props.modify(row),
    })
  }

  if (props.deleteApi) {
    defaultButtons.push({
      name: '删除',
      permission: name ? `${name}:DELETE` : '',
      onClick: () => props.handleDelete(row),
    })
  }

  const obj = {}

  for (let i = 0; i < defaultButtons.length; i++) {
    obj[defaultButtons[i].name] = defaultButtons[i]
  }

  for (let i = 0; i < actionButtons.length; i++) {
    if (obj[actionButtons[i].name]) {
      obj[actionButtons[i].name] = {
        ...obj[actionButtons[i].name],
        ...actionButtons[i],
      }
    } else {
      obj[actionButtons[i].name] = actionButtons[i]
    }
  }

  const buttons = Object.keys(obj).map((k) => obj[k])

  return buttons.length ? (
    <span
      style={{
        marginLeft: type === 'leftButton' ? '10px' : '0px',
        marginRight: type === 'leftButton' ? '10px' : '0px',
      }}
    >
      {buttons.map((b) => {
        const data = {
          props: {
            type: 'text',
            size: 'mini',
            disabled: b.disabled,
          },
          directives: [],
          on: {
            click: () => b.onClick(row),
          },
        }

        if (type === 'leftButton') {
          data.props.type = 'default'
          data.props.size = 'small'
        }

        if (b.permission) {
          const arr = b.permission.split(':')
          const arg = arr[0]
          const value = arr[1]

          data.directives.push({
            name: 'permission',
            arg,
            value,
          })
        }

        if (typeof data.props.disabled === 'function') {
          data.props.disabled = data.props.disabled(row)
        }

        return <el-button {...data}>{b.name}</el-button>
      })}
    </span>
  ) : null
}
</script>
